import { SalesAvailabilityState } from './../../store/sales-availability/sales-availability.reducer';
import { Store } from '@ngrx/store';
import { MasterSlot,SlotsPerDay } from '../../shared/models/slot-management.model';
import { Observable,Subject, Subscription } from 'rxjs';
import { ChangeDetectorRef, Component,OnDestroy, OnInit} from '@angular/core';
import * as fromSalesAvailabilityActions from '../../store/sales-availability/sales-availability.actions';
import * as fromSalesAvailabilitySelector from '../../store/sales-availability/sales-availability.selectors';
import { MatDialog } from '@angular/material/dialog';
import { ConfirmDialogComponent } from '../../shared/components/confirm-dialog/confirm-dialog.component';
import { INavigateAway } from '../../shared/guards/NavigationGuard';
import { exitConfig, unsubscribeSubscriptions } from '../../shared/services/util.service';
import { SubscriptionList } from '../../shared/models/asp.types';


@Component({
  selector: 'app-sales-capacity',
  templateUrl: './sales-capacity.component.html',
  styleUrls: ['./sales-capacity.component.scss']
})
export class SalesCapacityComponent implements OnInit, OnDestroy,INavigateAway {
  subscriptions: SubscriptionList = {};
  slotDetails$: Observable<SlotsPerDay[]>;
  viewMode = 'Shop';
  maxAndMasterSlots$: Observable<{ max: any, masterSlot: MasterSlot[] }>;
  masterSlotsLoading$: Observable<boolean>;
  tableValueInfo = [
    {value : 'departmentCapacity.blank', description : 'departmentCapacity.notLimitedToANumberOfAppointmentsForTheTimePeriod'},
    {value : '0', description : 'departmentCapacity.blocksTheTimePeriod'},
    {value : 'departmentCapacity.numericValue', description : 'departmentCapacity.setsANumberOfAppointmentsForTheTimePeriod'}]

    //save clicked 
    isAppPerTimeDaySaveClicked=false
    isSavedClicked=false;

    //cancel clicked
    isCancelClicked=false;
    isAppPerTimePeriodCancleClicked=false

   //forms edited
    isAppointmentPerDayEdited=false;
    isPerTimePeriodEdited=false;
    bothFormsEdited=false;
    
    slotsUpdated$:Observable<boolean>;

  constructor(
    private readonly dialog: MatDialog,
    private readonly salesAvailabilityState: Store<SalesAvailabilityState>,
    private readonly cdr: ChangeDetectorRef) {
    this.salesAvailabilityState.dispatch(new fromSalesAvailabilityActions.LoadMasterSlots());
    this.salesAvailabilityState.dispatch(new fromSalesAvailabilityActions.LoadShopMaxSlots());
    this.slotDetails$ = this.salesAvailabilityState.select(fromSalesAvailabilitySelector.selectShopMaxSlots);
    this.slotsUpdated$=this.salesAvailabilityState.select(fromSalesAvailabilitySelector.selectSlotsUpdated);
    this.maxAndMasterSlots$ = this.salesAvailabilityState.select(fromSalesAvailabilitySelector.selectMaxAndMasterSlots, { view: this.viewMode });
    this.masterSlotsLoading$ = this.salesAvailabilityState.select(fromSalesAvailabilitySelector.selectMasterSlotsLoading);
   }
  canExit():Observable<boolean> { 
    const result = new Subject<boolean>();
    const dialogRef = this.dialog.open(ConfirmDialogComponent, exitConfig
    );
    this.subscriptions.dialogRef = dialogRef.afterClosed().subscribe(event => {
      if (event.action === 'confirm') {
        this.onSaveClicked();
        this.subscriptions.slotUpadte = this.slotsUpdated$.subscribe(data=>{
          if(data)
          {
            result.next(true);
            result.complete();
          }
        })
      }
      else if(event.action === 'close'){
        result.next(true);
        result.complete();
      }
    });
    return result.asObservable(); 
  };

  ngOnInit() {
  }
  
  ngAfterContentChecked(): void { 
     if (!this.cdr['destroyed']) {
      this.cdr.detectChanges();
    }
   }
  onSaveChanges(slotDetails){
    this.salesAvailabilityState.dispatch(new fromSalesAvailabilityActions.UpdateShopMaxSlots({ shopMaxSlots: slotDetails,bothFormsEdited:this.bothFormsEdited }));
    this.isSavedClicked=false
  }

  ngOnDestroy() {
    unsubscribeSubscriptions(this.subscriptions);
    this.cdr.detach();
  }

  // returns if the forms are edited
  formsNotEdited()
  {
    return !this.isAppointmentPerDayEdited && !this.isPerTimePeriodEdited;
  }

  //save button clicked
  onSaveClicked()
  {
    this.isAppPerTimeDaySaveClicked= this.isAppointmentPerDayEdited?true:false
    this.isSavedClicked=this.isPerTimePeriodEdited?true:false
    this.bothFormsEdited=(this.isAppointmentPerDayEdited && this.isPerTimePeriodEdited) && this.isPerTimePeriodEdited?true:false
    // detect changes after manually calling onSaveClicked()
    if (!this.cdr['destroyed']) {
      this.cdr.detectChanges();
    }
  }

  //cancel button clicked 
  onCancelClicked()
  {
    this.isCancelClicked=this.isAppointmentPerDayEdited?true:false
    this.isAppPerTimePeriodCancleClicked=this.isPerTimePeriodEdited?true:false
  }

  //reset cancle button clicked value for 1st form
  resetCancleClickValue(event)
  {
    this.isCancelClicked=event
    this.isAppointmentPerDayEdited=event ;
  }

   //reset cancle button clicked value for 2nd form
  resetCancleClickedAppTable(event)
  {
    this.isAppPerTimePeriodCancleClicked=event
    this.isPerTimePeriodEdited=event;
  }

  //reset save button value cliked from 1st from
  resetSaveClickedValue(event)
  {
    this.isAppPerTimeDaySaveClicked=event;
  }

  //Appointment per day form edited 
  appointmentsPerDayFormEdited(event)
  {
    this.isAppointmentPerDayEdited=event;
  }

  //Appointment per time period form edited 
  appointmentPerTimePeriodEdited(event)
  {
    this.isPerTimePeriodEdited=event;
  }
}
